<template>
  <div style="padding: 0 40px" @keydown.enter="submitForm('ruleForm')">
    <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="0px" class="demo-ruleForm">
      <el-form-item prop="account">
        <el-input maxlength='450' type="text" v-model="ruleForm.account" autocomplete="off">
          <template slot="prepend">{{t('账号')}}</template>
        </el-input>
      </el-form-item>
      <el-form-item prop="pass">
        <el-input maxlength='450' type="password" v-model="ruleForm.pass" autocomplete="off">
          <template slot="prepend">{{t('密码')}}</template>
        </el-input>
      </el-form-item>
      <el-form-item class="btn__box">
        <el-button style="padding-right: 40px; padding-left: 40px" @click="resetForm('ruleForm')" icon="el-icon-delete">
          {{t('重置')}}
        </el-button>
        <el-button style="padding-right: 40px; padding-left: 40px" type="primary" @click="submitForm('ruleForm')"
          icon="el-icon-thumb">{{t('登录')}}
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { t } from '@/i18n/index'
import menus from '@/mixins/menus'
import { authAction, getWarehouseList } from "@/apis/auth";
import store from "@/store";
export default {
  name: "Login",
  mixins: [menus],
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(t('请输入密码')));
      } else {
        if (value.length < 3 || value.length > 18) {
          callback(new Error(t('密码长度在 3 到 5 个字符')));
        } else {
          callback();
        }
      }
    };
    return {
      t,
      ruleForm: {
        account: '',
        pass: ''
      },
      rules: {
        account: [
          { required: true, message: t('请输入账号'), trigger: 'blur' },
        ],
        pass: [
          { required: true, message: t('请输入密码'), trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ],
      }
    }
  },
  methods: {
    submitForm(formName) {
      const that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.loginOk()
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    loginOk: function () {
      const that = this
      const { account, pass } = that.ruleForm
      const params = {
        username: account,
        password: pass
      }
      authAction(params).then(({ code, data }) => {
        if (code === 0) {
          that.emitAuthInfo(data)
          // getWarehouseList().then(res => {
          //   data.warehouses.forEach(item => {
          //     res.data.forEach(item_son => {
          //       if (item.wareCode == item_son.wareCode) {
          //         item.wareName = item_son.wareName
          //       }
          //     })
          //   })
          //   store.dispatch('auth/setAuth', info).then(r => {
          //     // 保存用户信息
          //     that.getMenu(info.roles)
          //     that.$emit('change', {
          //       comName: 'ChooseStorehouse',
          //       authInfo: info
          //     })
          //   })
          //   // that.emitAuthInfo(data)
          // })
        }
      })
    },
    emitAuthInfo: function (info) {
      this.$message.success(this.t('去选择仓库！'))
      const that = this
      store.dispatch('auth/setAuth', info).then(r => {
        // 保存用户信息
        that.getMenu(info.roles)
        that.$emit('change', {
          comName: 'ChooseStorehouse',
          authInfo: info
        })
      })
    },

  }
}
</script>

<style scoped>
.btn__box ::v-deep.el-form-item__content {
  text-align: right;
}
</style>